import { useContext } from 'react';
import SessionContext from 'app/context/session';

export default () => useContext(SessionContext);
